import { Request } from '../../../httpClient/serverApi/requests/Request';

export class HasSiteLicensingConsumptionInfoRequest extends Request<{}, boolean> {
  constructor() {
    super('hasSiteLicensingConsumptionInfo', {});
  }
}
